import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";
import app from "@/main";

export class TaskResponser {
    public async response(task: ITask) {
        let childTasks: Array<ITask> = (await app.$http.get('/api/v1/task/'+ task.id +'/child-tasks')).data;

        // Bu fonksiyon paketi KAPATIR. Yalnızca işlenmemiş görevi kalmayan pakete
        // çağrılmalı; API de zaten paketi ancak o zaman döndürüyor. Buraya işlenmemiş
        // görevle gelinirse hatalı sayısı 0 çıkar ve paket BITTI_BASARILI olur —
        // tek dosya işlenmeden "başarılı" görünür, çocukları SIRADA'da asılı kalır.
        let islenmemis: number = childTasks.filter((value: ITask) => (
            value.status == TaskDurum.SIRADA ||
            value.status == TaskDurum.ISLENIYOR ||
            value.status == TaskDurum.DURAKLATILDI
        )).length;
        if (islenmemis > 0)
            throw new Error('Paket kapatılamadı: ' + islenmemis + ' işlenmemiş görev var.');

        let hataliGorevSayisi: number = childTasks.filter((value: ITask) => (value.status == TaskDurum.BITTI_EKSIK || value.status == TaskDurum.BITTI_HATALI)).length;
        if (hataliGorevSayisi == childTasks.length)
            task.status = TaskDurum.BITTI_HATALI
        else if (hataliGorevSayisi != childTasks.length && hataliGorevSayisi > 0)
            task.status = TaskDurum.BITTI_EKSIK;
        else
            task.status = TaskDurum.BITTI_BASARILI;
        // finished_at API tarafında bitiş durumuna geçişte damgalanır.
        // (Tam nesne PUT ediliyor ama zaman alanları artık fillable dışında,
        //  yani buradan gelen değerler sunucuda yok sayılır.)
        await app.$store.dispatch('putTask', task);
    }
}